<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
		<top-nevleft></top-nevleft>
		 <b-col class="p-0">
			<!-- <b-row class="breadcrumbrow mt-1 m-0">				
				<b-col>
				 <h5 class="text-center">Seller Dashboard</h5>
				</b-col>				
			</b-row> -->
			<b-container fluid>
				<b-row class="mt-3 mb-2">
					<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
						<!--<h3>Products Needtostock</h3> -->
					</b-col>
					<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					</b-col>
				</b-row>
			</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">WAITING</b-badge>
										<b-badge pill variant="success" v-else-if="row.value == 1">ACTIVE</b-badge>
										<b-badge pill variant="danger" v-else>REJECTED</b-badge>
									</template>
                                    <template v-slot:cell(stock_status)="row">
										<b-badge pill variant="warning" v-if="row.value == 0">Out of stock</b-badge>
										<b-badge pill variant="success" v-else-if="row.value == 1">In Stock</b-badge>
									</template>
                                    <template v-slot:cell(thumbnail)="row">
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-if="row.value==''" src="../../assets/icons/blank.svg">{{row}}</b-img>
                                        <b-img v-bind="thumbnailProps" rounded alt="" v-else :src="$root.MEDIAPATH+'products/'+row.value.replace('_rg','_th')">{{row}}</b-img>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1 icon-btn" @click="showUpdateModal(row.item, row.index, $event.target)"><b-icon icon="pencil" font-scale="1.6" ></b-icon></b-button>
										<b-button pill variant="danger" class="mr-1 icon-btn" @click="showDeleteModal(row.item)"><b-icon icon="trash" font-scale="1.6" ></b-icon></b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" title="Update Product Stock" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-container fluid>
                        <b-row class="mb-1">
                            <b-col cols="12">
                                <b-row class="mb-3">
                                    <b-col cols="3" class="text-right"><label class="font-sm">Stock Qty</label></b-col>
                                    <b-col>
                                        <b-form-input v-model="selectedItem.stock_qty" type="number" required size="sm" placeholder="0" min="0"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-3">
                                    <b-col cols="3" class="text-right"><label class="font-sm">Stock Status</label></b-col>
                                    <b-col>
                                        <b-form-select v-model="selectedItem.stock_status" size="sm" required>
											<b-form-select-option value="1">In Stock</b-form-select-option>
											<b-form-select-option value="0">Out of stock</b-form-select-option>
										</b-form-select>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
					</b-container>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
		</b-col>
		</b-row>
		</b-container>
		
		
	</div>
	
</template>
<script>
//import Header from "@/components/seller/Header.vue";
import Header from "@/components/header.vue";
import TreeviewPage from "@/components/seller/nevleft.vue";
import Footer from "@/components/footer-admin.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
	},
	mounted(){
		//var self = this;
		//Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            product_inf: {},			
			/*product_glb: '',*/
			model_maps: {},
			recordUrl: this.$root.WEBAPI+'sellerapi/products-needtostock',
			updateUrl: this.$root.WEBAPI+'sellerapi/update-stock',
			records: [],
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					active: true
				}
			],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
				{ key: 'category', label: 'category' },
				{ key: 'sku', label: 'SKU' },
				{ key: 'thumbnail', label: 'Thumbnail',
					formatter: (value, key, item) => { 
						//return item.image;
						return this.$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+ item.image;
					}
				},
				{ key: 'price', label: 'Price', class: 'text-right',
					formatter: (value) => { 
						return this.$root.currency(value.toFixed(2));
					},
				},
				{ key: 'special_price', label: 'Spl.Price', class: 'text-right',
					formatter: (value) => { 
						return this.$root.currency(value.toFixed(2));
					},
				},
                { key: 'stock_qty', label: 'Stock Qty', class: 'text-center' },
                { key: 'stock_status', label: 'Stock Status', class: 'text-center' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class: 'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {
				id: 0,
				stock_qty: 0,
				stock_status: 0
			},
			emptyItem: {
				id: 0,
				stock_qty: 0,
				stock_status: 0
			},
			counterindex:1
		};
	},
	methods: {
		
		showUpdateModal(item, index, button) {
			this.selectedItem = {
                id: item.id,
                stock_qty: item.stock_qty,
                stock_status: item.stock_status
            };
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
            bvModalEvt.preventDefault();
            
            self.axios.post(self.updateUrl, {
                data: this.selectedItem,
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.records = response.data.result.records;
                    
                    self.loading = false;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "zone_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
</style>